import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
  disabled?: boolean;
}

const ToponymyComponent = ({ onChange, values, disabled }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Codice"
          label="Codice"
          id="code"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.code || ''}
          onChange={(event) => {
            onChange('code', event.target.value);
          }}
          inputProps={{ maxLength: '6' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Specie"
          label="Specie"
          id="kind"
          name="kind"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.kind || ''}
          onChange={(event) => {
            onChange('kind', event.target.value);
          }}
          inputProps={{ maxLength: '30' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Denominazione"
          label="Denominazione"
          id="name"
          name="name"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.name || ''}
          onChange={(event) => {
            onChange('name', event.target.value);
          }}
          inputProps={{ maxLength: '100' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Fonte toponimo"
          label="Fonte toponimo"
          id="source"
          name="source"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.source || ''}
          onChange={(event) => {
            onChange('source', event.target.value);
          }}
          inputProps={{ maxLength: '1' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Codice Specie"
          label="Codice Specie"
          id="kindCode"
          name="kindCode"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.kindCode || ''}
          onChange={(event) => {
            onChange('kindCode', event.target.value);
          }}
          inputProps={{ maxLength: '4' }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Fonte specie"
          label="Fonte specie"
          id="kindSource"
          name="kindSource"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.kindSource || ''}
          onChange={(event) => {
            onChange('kindSource', event.target.value);
          }}
          inputProps={{ maxLength: '1' }}
        />
      </Grid>
    </Grid>
  );
};

ToponymyComponent.displayName = 'Toponymy residence';

const Toponymy = memo(ToponymyComponent);

export default Toponymy;
